import React from 'react';

import Heading from '@atlaskit/heading';

import { PD_ICON } from 'src/lib/featureFlags';

import './modal.css';

const ModalContainer = ({ title, children }) => (
  <div className="pd-modal">
    <header>
      <img src={PD_ICON} alt="pd"/>
      <Heading size="medium">{title}</Heading>
    </header>
    <div>{children}</div>
  </div>
);

export default ModalContainer;
